<div id="register" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="register-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="assets/images/logos/svg/h-logotipo-ll-cinza.svg">
        </div>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            MÓDULO EXAMES
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            Selecione o seu local de atendimento. Todos os seus atendimentos serão no local selecionado, mas você pode
            troca-lo no menu principal.
        </div>

    </div>

    <div id="register-form-wrapper" fusePerfectScrollbar>
        <div id="register-form" style="padding-top: 128px;">
            <app-estabelecimento-lista></app-estabelecimento-lista>
        </div>
    </div>


</div>